
import React, {Component} from 'react'
import { connect } from 'react-redux'
import CdnImage from '../../components/cdnImage/cdnImage.js'
import PageBarView from './PageBarView.js'
import DockBarView from './DockBarView.js'
import SelectionView from '../../components/selectionView/SelectionView.js'
import LongPressComponent from '../../components/longPress/LongPressComponent.js'
import AllPageMenuModal from './AllPageMenuModal.js'
import {TbGridDots} from 'react-icons/tb';

const themeUtil = require('../../utils/view/themeUtil.js');
const beamerUtils = require('../../utils/beamer/beamerUtils.js');
const stringUtil = require('../../utils/string/stringUtil.js');
const configurationManager = require('../../utils/config/configurationManager.js');
const localizationUtils = require('../../utils/domain/localizationUtils.js');
const storefrontUtility = require('../../utils/domain/storefrontUtility.js');
const translator = require('../../utils/translator/translator.js');
const displaySettingsUtils = require('../../utils/domain/settings/displaySettingsUtils.js');
const controlSettingsUtils = require('../../utils/domain/settings/controlSettingsUtils.js');
const staffUtility = require('../../utils/domain/staff/staffUtility');
const staffAccessUtility = require('../../utils/domain/staff/staffAccessUtility.js');
const staffActivities = require('../../utils/domain/staff/staffActivities.js');
const cashFloatUtil = require('../../utils/domain/cashFloatUtil.js');

var navigationButtonsIds = require('./navigationButtonsIds');
var navigationHandler = require('./navigationHandler');
const stateManager = require('../../utils/state/stateManager.js');
const layoutCurrentPageIndexAction = require('../../utils/state/actions/views/layout/layoutCurrentPageIndexAction.js');
const currentStorefrontAction = require('../../utils/state/actions/storefronts/currentStorefrontAction.js');

class NavigationView extends Component 
{
    constructor(props)
    {
        super(props);
        this.state = {};

        this.state.displayNavigationSelectionView = false;
        this.state.displayStorefrontSelectionView = false;
        this.state.displayConfigurationSelectionView = false;
    }

    render()
    {
        return <div className='h-100'>
             
                    {this.renderStorefrontView()}
                    {this.renderBeamer()}
                    
                    <div style={{position:'fixed', top:'50%', left:'50%', transform:'translate(-50%, -50%)'}}>
                        {this.renderSystemLogo()}
                        <PageBarView/>
                    </div>
                    
                    <div style={{position:'fixed', bottom:0, width:'100%'}}>
                        
                        <div style={{marginBottom:'20px'}}>
                            {this.renderHelpContacts()}
                        </div>

                        
                        <div style={{background:'#FFFFFF', paddingTop:'30px', paddingBottom:'20px', borderTop:'1px solid #05149e'}}>
                            <DockBarView/>
                        </div>
                    </div>

                    {this.renderNavigationSelectionView()}
                    {this.renderStorefrontSelectionView()}
                    {this.renderConfigurationSelectionView()}
                </div>
    }

    renderSystemLogo()
    {
        let staffNameComponent = null;
        if (displaySettingsUtils.getDisplayLoginStaffName())
            staffNameComponent = <div className='primary-color' style={{marginTop:'10px', textAlign:'center'}}>
                                    {staffUtility.getLoginStaffCompleteName()}
                                </div>

        let sessionExpiryError = null;
        if (cashFloatUtil.isCashFloatSessionClosedOrExpired())
            sessionExpiryError = <div style={{marginTop:'10px', textAlign:'center', color:'var(--colors-error)'}}>
                                        {translator.getLabel("float_session_is_expired_or_closed")}
                                </div>

        var cloudName = configurationManager.getConfig().cdnAppCloudName;
        return <LongPressComponent
                    onClick={()=>
                    {
                        stateManager.getStore().dispatch(layoutCurrentPageIndexAction.createAction(0)); 
                    }}
                    onLongPress={()=>
                    {
                        this.state.displayConfigurationSelectionView = true;
                        this.setState({});
                    }}>
                    <div style={{marginBottom:'40px'}}>
                        <CdnImage cloudName={cloudName} height={Math.round(window.innerHeight * 0.25)} publicId={themeUtil.getResolvedLogo()}/>
                        {staffNameComponent}
                        {sessionExpiryError}
                    </div>
                </LongPressComponent>
    }

    renderHelpContacts()
    {
        var cloudName = configurationManager.getConfig().cdnAppCloudName;
        
        return <div className='primary-color' style={{textAlign:'center'}}>
                    <div className="d-flex flex-row justify-content-center align-items-center" style={{gap:"8px"}}>
                        
                        <div className='make-child-img-full-width' style={{width:"1.3rem", height:'1.7rem'}}>
                            <CdnImage cloudName={cloudName} width='0.05' publicId={themeUtil.getPublicId('whatsapp.png')}/>
                        </div>
                        <div >
                            {translator.getLabel("whatsapp_support")}: {localizationUtils.getSupportWhatsAppNumber()}
                        </div>
                        
                        <div className='make-child-img-full-width' style={{marginLeft:'60px', width:"1.3rem", height:'1.7rem'}}>
                            <CdnImage cloudName={cloudName} width='0.05' publicId={themeUtil.getPublicId('email.png')}/>
                        </div>
                        <div >
                            {translator.getLabel("email_support")}: {localizationUtils.getSupportEmailAddress()}
                        </div>

                        <div className='make-child-img-full-width' style={{marginLeft:'60px', width:"1.3rem", height:'1.7rem'}}>
                            <CdnImage cloudName={cloudName} width='0.05' publicId={themeUtil.getPublicId('phone.png')}/>
                        </div>
                        <div >
                            {translator.getLabel("phone_support")}: {localizationUtils.getSupportPhoneNumber()}
                        </div>

                        <div style={{position:'absolute',right:0, fontSize:'2rem', paddingLeft:'20px', paddingRight:'20px', paddingBottom:'20px'}} 
                             onClick={()=>
                             {
                                this.state.displayNavigationSelectionView = true;
                                this.setState({});
                             }}>
                            <TbGridDots size="2.4vw"/>
                        </div>
                    </div>
                </div>   
    }

    renderStorefrontView()
    {

        if (!displaySettingsUtils.getDisplayStorefrontSelection() || this.getApplicableStorefronts().length <= 1)
            return null;

        let onClick = null;
        let storefronts = this.getApplicableStorefronts();;
        if (storefronts.length  == 2)
        {
            onClick = ()=>
                        {
                            let nonSelectedPosStorefront = storefronts.find(p => !stringUtil.areStringSame(p.id, stateManager.getStore().getState().currentStorefrontId));
                            if (nonSelectedPosStorefront != null)
                                stateManager.getStore().dispatch(currentStorefrontAction.createAction(nonSelectedPosStorefront.id));      
                        }
        }
        else
        {
            onClick = ()=>
            {
                this.state.displayStorefrontSelectionView = true;
                this.setState({});
            }
        }

        return <div style={{position:'fixed', top:'20px', right:"0", textAlign:'end', marginRight:'20px'}}>
                    <div className='caption primary-color' onClick={onClick} style={{paddingTop:'20px', paddingBottom:'20px', width:'20vw',
                        border:'1px solid var(--colors-primary)', borderRadius:'10px', textAlign:'center', background:'white',
                        }}>
                        {storefrontUtility.getCurrentStorefront().name}
                    </div>
                </div>
    }

    renderNavigationSelectionView()
    {
        if (!this.state.displayNavigationSelectionView)
            return null;

        return <AllPageMenuModal onClose={()=>
                    {
                        this.state.displayNavigationSelectionView = false;
                        this.setState({});
                    }} />
    }

    renderStorefrontSelectionView()
    {
        if (!this.state.displayStorefrontSelectionView)
            return null;
        
        let storeFronts = this.getApplicableStorefronts();

        let selectedStorefrontId = stateManager.getStore().getState().currentStorefrontId;

        let selections = [];
        for (var index = 0; index < storeFronts.length; index++)
        {
            let selection = {};
            selection.caption = storeFronts[index].name;
            selection.isSelected = false;
            selection.id = storeFronts[index].id;
            if (selectedStorefrontId == storeFronts[index].id)
            {
                selection.isSelected = true;
            }
            selections.push(selection);
        }

        return <SelectionView selections={selections} caption={translator.getLabel("storefront_options")}
                onClose={()=>
                {
                    this.state.displayStorefrontSelectionView = false;
                    this.setState({});
                }}
                onSelection={(selection)=>
                {
                    stateManager.getStore().dispatch(currentStorefrontAction.createAction(selection.id)); 
                    stateManager.getStore().dispatch(layoutCurrentPageIndexAction.createAction(0));
                }}/>
    }

    getApplicableStorefronts()
    {
        if (controlSettingsUtils.getAllowAllStorefronts())
            return storefrontUtility.getAllStorefronts();

        return storefrontUtility.getPOSStorefronts();
    }

    renderConfigurationSelectionView()
    {
        if (!this.state.displayConfigurationSelectionView)
            return null;
        
        let selections = [];
        let selection = {};
        selection.caption = translator.getLabel("settings");
        selection.id = navigationButtonsIds.settings;
        selection.isDisabled = !staffAccessUtility.canCurrentStaffPerformActivity(staffActivities.canChangeSettings);
        selection.isSelected = false;
        selections.push(selection);

        selection = {};
        selection.caption = translator.getLabel("layout");
        selection.id = navigationButtonsIds.navigationDesigner;
        selection.isDisabled = !staffAccessUtility.canCurrentStaffPerformActivity(staffActivities.canChangeLayout);
        selection.isSelected = false;
        selections.push(selection);

        return <SelectionView selections={selections} caption={translator.getLabel("configuration_options")}
                onClose={()=>
                {
                    this.state.displayConfigurationSelectionView = false;
                    this.setState({});
                }}
                onSelection={(selection)=>
                {
                    navigationHandler.handleNavigationButtonOnClick(selection.id);
                }}/>
    }

    renderBeamer()
    {
        if (!beamerUtils.isInitialized())
            return;

        var cloudName = configurationManager.getConfig().cdnAppCloudName;
        var size = Math.round(window.innerWidth*0.023);
        return <div id="beamerPlaceHolder" style={{position:'fixed', top:'20px', left:"0", textAlign:'end', marginLeft:'20px'}}>

                    <div style={{width:window.innerWidth*0.10, height: window.innerWidth*0.06, border:'1px solid var(--colors-primary)', borderRadius:'10px', background:"white"}}>
                        <div style={{position:'relative', top:'50%', left:'50%', transform:'translate(-50%, -50%)', textAlign:'center'}}>
                            
                            <CdnImage cloudName={cloudName} width={size} publicId={themeUtil.getPublicId(`whatsnew.png`)}/>
                            <div className='primary-color' style={{marginTop:'5px', paddingLeft:'10px', paddingRight:'10px'}}>
                                {translator.getLabel("whats_new")}
                            </div>
                            
                        </div>
                    </div>
                </div>
    }
}


const mapStateToProps = state => 
{
    return { 
                currentStorefrontId: state.currentStorefrontId,
                settingsChangedTimeStamp: state.settingsChangedTimeStamp,
                cashFloatPayload: cashFloatUtil.getLoadedFloatSession()
           }
}

export default connect(mapStateToProps)(NavigationView)
